module.exports = __webpack_public_path__ + "static/img/chatb.2307de6.png";


//////////////////
// WEBPACK FOOTER
// ./static/chatb.png
// module id = 5cr8
// module chunks = 1